import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Field, reduxForm } from 'redux-form'

import { tryToUpdateEmail, tryToFetchMyAccountInfo } from '../../actions/actions.export.js';
import Button from '../Button/Button.js'
import Checkbox from '../Checkbox/Checkbox.js'
import Tabs from '../Tabs/Tabs.js'
import CustomField from '../CustomField/CustomField.js'

class UserSettingsEmailForm extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      // email: props.user.emailForm.lastSubmit.email || props.user.email,
    }

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(e){
    const { dispatch } = this.props;
    console.log({
      text: this.state.text,
      password: this.state.password,
      email: this.state.email,
      multi: this.state.multi
    });
    // dispatch(tryToUpdateEmail({
    //   email: this.state.email,
    //   public_email: this.state.public_email
    // }))
    e.preventDefault();
  }


  render(){
    const { dispatch, user } = this.props; 
    const state = this.state;

    return (
      <div>
        <form onSubmit={this.handleSubmit}>
          <p>Text:</p>
          <CustomField 
            name="text" 
            type="text"
            component="input"
            required={true}
            placeholder="Placeholder goes here"
            label="This is the label."
            description="This is the description."
            onChange={(v) => { this.setState({ text: v }); }}
            />
          <hr/>
          <p>Text no description:</p>
          <CustomField 
            name="text" 
            type="text"
            component="input"
            required={true}
            placeholder="Placeholder goes here"
            label="This is the label."
            onChange={(v) => { this.setState({ text: v }); }}
            />
          <hr/>

          <p>Pass:</p>
          <CustomField 
            name="password" 
            type="password"
            component="input"
            required={true}
            placeholder="Placeholder goes here"
            label="This is the label."
            description="This is the description."
            onChange={(v) => { this.setState({ password: v }); }}
            tooltipErrors={true}
            minLength={8}
            />
          <hr/>

          <p>Email:</p>
          <CustomField 
            name="email" 
            type="text"
            regex="email"
            component="input"
            required={true}
            placeholder="Placeholder goes here"
            label="This is the label."
            description="This is the description."
            onChange={(v) => { this.setState({ email: v }); }}
            />
          <hr/>

          <p>multi:</p>
          <CustomField 
            name="multi" 
            type="text"
            component="input"
            multipleRows={true}
            minRows={10}
            required={true}
            placeholder="Placeholder goes here"
            label="This is the label."
            description="This is the description."
            onChange={(v) => { this.setState({ multi: v }); }}
            />
        
          <div className="list-right">
            <Button 
              submit={true}
              size="medium" 
              thinking={user.tryingToUpdateEmail} 
              successful={user.successfullyUpdatedEmail}
              failed={user.failedToUpdateEmail}
              color="success" 
              display="Save Changes" 
              onClick={this.handleSubmit}
            />
          </div>
        </form>
      </div>
    )
  }
}


UserSettingsEmailForm = reduxForm({
  // a unique name for the form
  form: 'UserSettingsEmailForm',
  enableReinitialize: true,
  destroyOnUnmount: false
})(UserSettingsEmailForm)

UserSettingsEmailForm = connect((state, ownProps) => {
  const { user } = state;

  var initialValues = {
    text: '',
    password: 'password',
    email: 'abcd@example.com',
    multi: 'multi\nline\ntext',
  };

  return {
    user,
    initialValues
  }
})(UserSettingsEmailForm);

export default UserSettingsEmailForm;



// WEBPACK FOOTER //
// ./src/components/_TestComponents/TestForm.js